// extracted by mini-css-extract-plugin
export var contentBody = "_af-9";
export var headerImage = "_af-2";
export var imageButton = "_af-7";
export var imageButtonIcon = "_af-8";
export var imageHeader = "_af-4";
export var imageHeaderText = "_af-5";
export var imageOverlay = "_af-3";
export var imageTitle = "_af-6";
export var imageWrapper = "_af-1";
export var taskList = "_af-a";
export var widget = "_af-0";